import { ScrollStrategy } from '@angular/cdk/overlay';

// ページのスクロールを止めている数（ダイアログを重ねて開いた場合や、検索条件のパネルと同時の場合に、
// 最後の1つが閉じるまで止めたままにするため）
let lockCount = 0;

// 止めたときのスクロール位置（戻したときに、万一位置が変わっていたら元に戻すため）
let lockedScrollY = 0;

/**
 * ページ自体のスクロールを止める（html の overflow を hidden にする）。
 * 画面を位置で固定する方法（Material 標準の block）と違い、iPhone・iPad の Safari でも、
 * 画面の下のツールバーが縮んだ状態で表示がずれたり、ダイアログを押せなくなったりしない。
 * body には付けない（body は高さが画面と同じ（100%）のため、body で隠すとページの高さが画面1枚分になり、
 * スクロール位置がページの先頭に戻ってしまうため）。
 * unlockPageScroll と必ず対にして呼ぶこと
 */
export function lockPageScroll(): void {
  if (lockCount++ === 0) {
    lockedScrollY = window.scrollY;
    document.documentElement.style.overflow = 'hidden';
  }
}

/** lockPageScroll で止めたスクロールを戻す（止めている数が0になったときだけ戻す） */
export function unlockPageScroll(): void {
  if (lockCount === 0) {
    return;
  }
  if (--lockCount === 0) {
    document.documentElement.style.overflow = '';
    if (window.scrollY !== lockedScrollY) {
      window.scrollTo(0, lockedScrollY);
    }
  }
}

/** ダイアログを開いている間、lockPageScroll でページのスクロールを止める（iPhone・iPad 用） */
export class PageScrollLockStrategy implements ScrollStrategy {
  private locked = false;

  attach(): void {}

  enable(): void {
    if (!this.locked) {
      this.locked = true;
      lockPageScroll();
    }
  }

  disable(): void {
    if (this.locked) {
      this.locked = false;
      unlockPageScroll();
    }
  }

  detach(): void {
    this.disable();
  }
}
